import { FieldValues } from "react-hook-form";
import { Feeds } from "../../types/api/Feed";
import { SelectedFile } from "../../types/PostSelection";

export function getSelectedFileKey(file: SelectedFile) {
  const originalPath = file.imageDerivatives?.originalPath;
  if (originalPath) return `image:${originalPath}`;

  const videoName = file.name.replace(/\.video-thumbnail\.jpg$/i, "");
  return `media:${file.mine_type}:${videoName}`;
}

export function resolvePostMediaSelections(
  feeds: Feeds,
  values: FieldValues,
  sourceFiles: SelectedFile[]
) {
  const feedSelections = feeds.map((feed) => {
    const selectedFiles = values[feed.slug!]?.selected_files as
      | SelectedFile[]
      | undefined;

    return {
      feed,
      files:
        selectedFiles && selectedFiles.length > 0
          ? selectedFiles
          : sourceFiles,
    };
  });

  const filesByKey = new Map<string, SelectedFile>();
  for (const { files } of feedSelections) {
    for (const file of files) {
      const key = getSelectedFileKey(file);
      if (!filesByKey.has(key)) {
        filesByKey.set(key, file);
      }
    }
  }

  return {
    allFiles: Array.from(filesByKey.values()),
    feedSelections,
  };
}
